import type { StateCreator } from 'zustand';
import create from 'zustand';

/*
 * Header brand for the event-details view. The event layout already fetched the
 * event, so it publishes the title/subtitle/link here and the header's `Brand`
 * reads it — no extra backend call. Cleared when the layout unmounts.
 */
export interface EventBrand {
  title: string;
  subtitle?: string;
  /** Stream/webplayer URL the title links to. */
  link?: string;
}

interface EventBrandStore {
  brand?: EventBrand;
  setBrand: (brand?: EventBrand) => void;
}

const store: StateCreator<EventBrandStore> = (set) => ({
  brand: undefined,
  setBrand: (brand): void => {
    set({ brand });
  }
});

export const useEventBrand = create<EventBrandStore>(store);
